import clsx from 'clsx';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, variants } from '@/components/Elements';

export type ConfirmDialogProps = {
  title?: React.ReactNode | string;
  description?: React.ReactNode | string;
  actionButton?: string;
  cancelButton?: string;
  onActionButtonVariant?: keyof typeof variants;
  onCancelButtonVariant?: keyof typeof variants;
  onActionButton: () => void;
  onCancelButton: () => void;
  actionButtonToRight?: boolean;
};

export const ConfirmDialog = ({
  title,
  description,
  actionButton,
  cancelButton,
  onActionButton,
  onActionButtonVariant = 'primary',
  onCancelButtonVariant = 'ghost',
  onCancelButton,
  actionButtonToRight = false,
}: ConfirmDialogProps) => {
  const { t } = useTranslation();

  return (
    <div className="w-full h-full">
      {title && <div className="text-md-black text-lg">{title}</div>}
      <div className="mt-6">{description}</div>
      <div
        className={clsx('ml-auto flex mt-10 gap-4', {
          'flex-row-reverse justify-start': actionButtonToRight,
          'justify-end': !actionButtonToRight,
        })}
      >
        <Button variant={onCancelButtonVariant} onClick={onCancelButton}>
          {cancelButton || t('DialogConfirm.cancelButton')}
        </Button>
        <Button variant={onActionButtonVariant} onClick={onActionButton}>
          {actionButton || t('DialogConfirm.actionButton')}
        </Button>
      </div>
    </div>
  );
};
